import React from 'react';

function Contact() {

    return (
        <>
            <div className="inner-page-banner-area" style={{ backgroundImage: 'url("/images/About_images/about_banner.jpg")' }}>
                <div className="container">
                    <div className="pagination-area">
                        <h1>Contact Us</h1>
                    </div>
                </div>
            </div>

            <div className='contact-us-page2-area'>
                <div className='container'>
                    <div className='row'>

                        {/* Registered Office */}
                        <div className='col-lg-4 col-md-4 col-sm-4 col-xs-12'>
                            <h2 className='title-default-left title-bar-high'>Reg. Address</h2>
                            <div className='contact-us-info2'>
                                <ul>
                                    <li>
                                        <i className='fa fa-map-marker'></i>
                                        <b> Registered Office:</b><br />
                                        1/22, Second Floor, Asaf Ali Road,<br />
                                        New Delhi,<br />
                                        Delhi - India 110002
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Corporate Office */}
                        <div className='col-lg-4 col-md-4 col-sm-4 col-xs-12'>
                            <h2 className='title-default-left title-bar-high'>Corporate Office</h2>
                            <div className='contact-us-info2'>
                                <ul>
                                    <li>
                                        <i className='fa fa-map-marker'></i>
                                        <b> Corporate Office:</b><br />
                                        Nehru Chowk, Cantonment,<br />
                                        (Aurangabad) Ch. Sambhajinagar,<br />
                                        Maharashtra, India, 431001
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Contact */}
                        <div className='col-lg-4 col-md-4 col-sm-4 col-xs-12'>
                            <h2 className='title-default-left title-bar-high'>E-Mail Or Call</h2>
                            <div className='contact-us-info2'>
                                <ul>
                                    <li>
                                        <i className='fa fa-phone'></i>
                                        +91 92 843 044 34<br />
                                        +91 76 200 200 54<br /><br />

                                        <i className='fa fa-envelope'></i>
                                        <br />
                                        info@ittcouncil.com
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Regional Offices */}
                        <div className='col-lg-6 col-md-6 col-sm-12'>
                            <h2 className='title-default-left title-bar-high'>Regional Offices</h2>

                            <div className='contact-us-info2'>

                                <ul>
                                    <li>
                                        <i className='fa fa-map-marker'></i>
                                        <b> Uttar Pradesh Regional Office</b><br />
                                        Geohunt Solutions Pvt. Ltd<br />
                                        GT Road (NH2), (RTO Office, Station Road)<br />
                                        Mughal Sarai, Chandauli, U.P - 232120
                                    </li>
                                </ul>

                            </div>
                        </div>

                        {/* Contact Persons */}
                        <div className='col-lg-6 col-md-6 col-sm-12'>
                            <h2 className='title-default-left title-bar-high'>Contact</h2>

                            <div className='contact-us-info2'>

                                <ul>
                                    <li>
                                        <i className='fa fa-phone'></i>
                                        <b> Uttar Pradesh Regional Office</b><br />
                                        Dr. Dinesh Kumar
                                    </li>
                                </ul>

                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className='col-lg-8 col-md-8 col-sm-12'>
                            <h2 className='title-default-left title-bar-high'>Contact With Us</h2>

                            <div className='contact-form2'>
                                <form>
                                    <fieldset>
                                        <div className='row'>

                                            <div className='col-lg-6'>
                                                <div className='form-group'>
                                                    <input type="text" placeholder="Name*" className="form-control" required />
                                                </div>
                                            </div>

                                            <div className='col-lg-6'>
                                                <div className='form-group'>
                                                    <input type="email" placeholder="Email*" className="form-control" required />
                                                </div>
                                            </div>

                                            <div className='col-lg-6'>
                                                <div className='form-group'>
                                                    <input type="text" placeholder="Mobile No.*" className="form-control" required />
                                                </div>
                                            </div>

                                            <div className='col-lg-6'>
                                                <div className='form-group'>
                                                    <input type="text" placeholder="City Name*" className="form-control" required />
                                                </div>
                                            </div>

                                            <div className='col-lg-12'>
                                                <div className='form-group'>
                                                    <textarea placeholder="Message*" className="textarea form-control" rows="6" required></textarea>
                                                </div>
                                            </div>

                                            <div className='col-lg-4'>
                                                <button type='submit' className='default-big-btn'>Send Message</button>
                                            </div>

                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;